var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('button', {
    attrs: {
      "disabled": _vm.isStarting
    },
    on: {
      "click": _vm.start
    }
  }, [_vm._v("开始聊天")]), _c('button', {
    attrs: {
      "disabled": !_vm.isStarting
    },
    on: {
      "click": _vm.stop
    }
  }, [_vm._v("停止对话")]), _c('span', [_vm._v(_vm._s(_vm.status))]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };